/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a4f5711c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-card"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("支付回调地址");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加游戏商品");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("IP白名单");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加账号");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定");
import GoodsConf from './goodsConf.vue';
import AddGameGoods from './addGameGoods.vue';
import TestAccount from './testAccount.vue';
import AddAccount from './addAccount.vue';
import IpWhiteList from './ipWhiteList.vue';
import AddCallback from './addCallback.vue';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const useApp = useAppStore();
    const active = ref('goodsConf');
    const testActive = ref('testAccount');
    const goodsConfRef = ref();
    const addGameGoodsRef = ref();
    const addAccountRef = ref();
    const ipWhiteListRef = ref();
    const addCallbackRef = ref();
    const gameInfo = computed(() => useApp.gameInfo);
    const panes = ref([{
      title: '游戏商品',
      key: 'goodsConf',
      level: 0
    }, {
      title: '添加商品',
      key: 'addGameGoods',
      level: 1
    }, {
      title: '编辑商品',
      key: 'editGoods',
      level: 1
    }]);
    const testPanes = ref([{
      title: '测试账号',
      key: 'testAccount',
      level: 0
    }, {
      title: '添加账号',
      key: 'addAccount',
      level: 1
    }, {
      title: 'IP白名单',
      key: 'ipWhiteList',
      level: 1
    }]);
    watch(() => gameInfo.value.Id, val => {
      if (val) {
        active.value = 'goodsConf';
        testActive.value = 'testAccount';
      }
    });
    const handleClickTo = text => {
      active.value = text;
    };
    const handleClickTestTo = text => {
      testActive.value = text;
    };
    const handleConfirm = () => {
      if (active.value === 'editGoods') {
        goodsConfRef.value.handleConfirm();
      }
      if (active.value === 'addGameGoods') {
        addGameGoodsRef.value.handleConfirm();
      }
    };
    const handleSuccess = () => {
      testActive.value = 'testAccount';
    };
    const handleConfirmTest = () => {
      if (testActive.value === 'addAccount') {
        addAccountRef.value.handleConfirm();
      }
      if (testActive.value === 'ipWhiteList') {
        ipWhiteListRef.value.handleConfirm();
      }
    };
    const handleActive = e => {
      active.value = e;
    };
    const handleOpenCallback = () => {
      addCallbackRef.value.show();
    };
    const cardHeight = ref(0);
    onMounted(() => {
      const dom = document.querySelector('.container-card');
      const height = dom === null || dom === void 0 ? void 0 : dom.clientHeight;
      cardHeight.value = height / 2 - 140;
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_u_card, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => active.value = $event),
        panes: panes.value
      }, {
        extra: _withCtx(() => [active.value === 'goodsConf' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOpenCallback())
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : _createCommentVNode("", true), active.value === 'goodsConf' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleClickTo('addGameGoods'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true), active.value === 'editGoods' || active.value === 'addGameGoods' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => handleConfirm())
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(GoodsConf, {
          ref_key: "goodsConfRef",
          ref: goodsConfRef,
          active: active.value,
          onOnActive: handleActive,
          height: cardHeight.value
        }, null, 8, ["active", "height"]), _createVNode(AddGameGoods, {
          gameInfo: _unref(gameInfo),
          ref_key: "addGameGoodsRef",
          ref: addGameGoodsRef,
          onOnActive: handleActive
        }, null, 8, ["gameInfo"])]),
        _: 1
      }, 8, ["modelValue", "panes"]), _createVNode(_component_u_card, {
        class: "marginT20",
        modelValue: testActive.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => testActive.value = $event),
        panes: testPanes.value
      }, {
        extra: _withCtx(() => [testActive.value === 'testAccount' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[4] || (_cache[4] = $event => handleClickTestTo('ipWhiteList'))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true), testActive.value === 'testAccount' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => handleClickTestTo('addAccount'))
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })) : _createCommentVNode("", true), testActive.value === 'addAccount' || testActive.value === 'ipWhiteList' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          onClick: _cache[6] || (_cache[6] = $event => handleConfirmTest())
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(TestAccount, {
          gameInfo: _unref(gameInfo),
          active: testActive.value,
          height: cardHeight.value
        }, null, 8, ["gameInfo", "active", "height"]), _createVNode(AddAccount, {
          ref_key: "addAccountRef",
          ref: addAccountRef,
          gameInfo: _unref(gameInfo),
          onSuccess: handleSuccess
        }, null, 8, ["gameInfo"]), _createVNode(IpWhiteList, {
          ref_key: "ipWhiteListRef",
          ref: ipWhiteListRef,
          gameInfo: _unref(gameInfo)
        }, null, 8, ["gameInfo"]), _createVNode(AddCallback, {
          ref_key: "addCallbackRef",
          ref: addCallbackRef,
          gameInfo: _unref(gameInfo)
        }, null, 8, ["gameInfo"])]),
        _: 1
      }, 8, ["modelValue", "panes"])]);
    };
  }
});